// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3oRFz","Logo":"Toolbar_Logo__nIsQR","DesktopOnly":"Toolbar_DesktopOnly__2_M17"};